import { handleResponse } from '../utils';
import axios from '@/util/axios';

export default {
  // code 模式登录：外部传入的一次性 code 换取登录(后端调 EIAM 中间件换 AD)
  userCodeLogin(params) {
    return new Promise((resolve, reject) => {
      axios
        .get('/rocheManage/sys/callback/code?code='+params.code)
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },

  // p_token 模式(兼容保留)
  userTokenLogin(params) {
    return new Promise((resolve, reject) => {
      axios
        .get('/rocheManage/sys/callback/portal?p_token='+params.p_token)
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },

  userCookieLogin(params) {
    // debugger
    return new Promise((resolve, reject) => {
      axios
        .post('/rocheManage/sys/login3', {
          username: params.username,
          password: params.password
        })
        .then(
          (response) => {
            resolve(response);
          },
          (err) => {
            reject(err);
          }
        );
    });
  },
  
  // 获取用户信息
  getUserInfo(params) {
    return new Promise((resolve, reject) => {
      axios.post('/rocheManage/sys/userInfo').then(
        (response) => {
          resolve(response);
        },
        () => {}
      );
    });
  }
  
};



// WEBPACK FOOTER //
// ./src/api/login.js